import { CategoryBox } from '@ori/presentation-components';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';

import { useTranslations } from '../../../hooks/useTranslations';
import { NEXT_CATALOGUE } from '../../common';
import { Catalogue } from './styles';
import type { NextCatalogueProps } from './types';

export const NextCatalogue: FC<NextCatalogueProps> = (props) => {
  const { translations } = useTranslations();
  const { getTestId } = useTestId();

  const {
    onClick,
    catalogue: { url, title, imageUrl, validity },
  } = props;

  return (
    <Catalogue
      data-testid={getTestId(NEXT_CATALOGUE)}
      onClick={onClick}
    >
      <CategoryBox
        key={title}
        title={title}
        imageUrl={imageUrl}
        description={validity}
        relativeUrl={url ?? ''}
        buttonText={translations.view}
      />
    </Catalogue>
  );
};
